import React from 'react'
import { BaseText, BaseView } from '@/components/base'
import { LabelAmount } from '@/components/LabelAmount'
import { currencyUtils } from '@/utils'

const { formatDynamicCurrency, parseAmountToFloat } = currencyUtils

interface AmountAndConversionProps {
  cryptoAmount: {
    amount: string
    code: string
  }
  fiatAmount: {
    amount: string
    code: string
  }
  showDecimals?: boolean
  shouldMaskStablecoinAsFiat?: boolean
  skeletonActive?: boolean
  containerStyle?: React.CSSProperties
}

export const AmountAndConversion: React.FC<AmountAndConversionProps> = ({
  cryptoAmount,
  fiatAmount,
  showDecimals = true,
  shouldMaskStablecoinAsFiat = false,
  skeletonActive = false,
  containerStyle,
}) => {
  // Форматируем фиатную сумму для отображения
  const fiatAmountValue = parseAmountToFloat({
    amount: fiatAmount.amount || '0',
    decimalSeparator: '.',
  })

  // Показываем конвертацию только если есть значимая сумма
  const shouldShowConversion = fiatAmountValue > 0

  const relativeFiatFormatted = shouldShowConversion
    ? formatDynamicCurrency({
        amount: fiatAmountValue,
        currencyCode: fiatAmount.code,
        showDecimals,
      })
    : formatDynamicCurrency({
        amount: 0,
        currencyCode: fiatAmount.code,
        showDecimals,
      })

  return (
    <BaseView gap={8} center style={containerStyle}>
      {/* Основная сумма - как LabelAmount в RN (без centralize) */}
      <LabelAmount
        amount={cryptoAmount.amount}
        currencyCode={cryptoAmount.code}
        showDecimals={showDecimals}
        shouldMaskStablecoinAsFiat={shouldMaskStablecoinAsFiat}
        skeletonActive={skeletonActive}
      />

      {/* Конвертация - как в RN (с символом ≈) */}
      <BaseText
        fontSize={18}
        fontFamily="medium"
        color="label.description"
        skeletonActive={skeletonActive}
      >
        ≈{relativeFiatFormatted}
      </BaseText>
    </BaseView>
  )
}

export default AmountAndConversion
